/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectGroupHasMonitoredObjectSerializer
 */
export interface ReadOnlyMonitoredObjectGroupHasMonitoredObjectSerializer {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReadOnlyMonitoredObjectGroupHasMonitoredObjectSerializer
     */
    monitoredObjectIds: Array<number>;
}

export function ReadOnlyMonitoredObjectGroupHasMonitoredObjectSerializerFromJSON(json: any): ReadOnlyMonitoredObjectGroupHasMonitoredObjectSerializer {
    return ReadOnlyMonitoredObjectGroupHasMonitoredObjectSerializerFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectGroupHasMonitoredObjectSerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectGroupHasMonitoredObjectSerializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjectIds': json['monitored_object_ids'],
    };
}

export function ReadOnlyMonitoredObjectGroupHasMonitoredObjectSerializerToJSON(value?: ReadOnlyMonitoredObjectGroupHasMonitoredObjectSerializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_object_ids': value.monitoredObjectIds,
    };
}


